(function($) {
    //$('.datepicker').pickadate();
}(jQuery));
